import { Outlet } from 'react-router-dom';
import { Sidebar } from './sidebar';
import { TopNavigation } from './top-navigation';
import { PageProvider } from '@/contexts/page-context';
import { SidebarProvider, SidebarInset } from 'prosci-ui';
import { useMasquerade } from '@/hooks/use-masquerade';

function AdminLayoutContent() {
  const { isMasquerading, masqueradedUserEmail, stopMasquerading } = useMasquerade();

  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- CSS custom property, and prosci-ui's own React types differ from the app's
    <SidebarProvider defaultOpen={true} style={{ '--sidebar-top': '3.5rem' } as any}>
      <div className="fixed inset-x-0 top-0 z-50">
        <TopNavigation />
      </div>
      <Sidebar />
      <SidebarInset className="max-w-screen bg-muted pt-14">
        <Outlet />
      </SidebarInset>
      {/* Masquerade Banner - Sticky footer warning when admin is impersonating a user */}
      {isMasquerading && (
        <div
          style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 2147483647, // Max z-index to ensure it's above everything
            backgroundColor: '#f59e0b',
            color: '#1f2937',
            padding: '10px 16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '16px',
            fontSize: '14px',
            fontWeight: 500,
            boxShadow: '0 -2px 4px rgba(0,0,0,0.1)',
            pointerEvents: 'auto',
          }}
        >
          <span>
            <strong>Masquerading as:</strong> {masqueradedUserEmail}
          </span>
          <button
            type="button"
            onClick={stopMasquerading}
            style={{
              backgroundColor: '#1f2937',
              color: 'white',
              padding: '6px 16px',
              borderRadius: '4px',
              border: 'none',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: 600,
              pointerEvents: 'auto',
            }}
          >
            Stop Masquerading
          </button>
        </div>
      )}
    </SidebarProvider>
  );
}

export function AdminLayout() {
  return (
    <PageProvider>
      <AdminLayoutContent />
    </PageProvider>
  );
}